import { convertFromCentsToDollars } from "utils/calculateCurrency/calculateTotalCurrency";

export const buildTableMobileThs = (plans = []) => {
  if (!plans?.length) {
    return [];
  }

  return plans.map((plan) => ({
    planName: {
      id: `${plan.id}_name`,
      value: plan.name,
      planId: plan.id
    },
    price: {
      id: `${plan.id}_price`,
      value: convertFromCentsToDollars(plan.price),
      planId: plan.id
    }
  }));
};
